export function getDefaultFilters(filters) {
    return filters.reduce((defaultFilters, filterConfig) => {
        let defaultItem = filterConfig.options.find(f => f.isDefault);
        if (defaultItem) {
            defaultFilters[filterConfig.name] = defaultItem.value
        } else {
            console.error(`filter ${filterConfig.name} doesn't have a default value. the filter will be ignored`);
        }
        return defaultFilters;
    }, {})
}



// WEBPACK FOOTER //
// ./app/components/listing/js/listing-helper.js